import { Component } from 'react'
import { connect } from "react-redux"
import { updateData, loadData } from '../Redux/actions';
import store from '../Redux/store';
import uuid from 'react-uuid'
import { updateGlobalState } from '../Redux/actions'

class SyncQueue extends Component {
    // constructor(props){
    //     super(props)
    // }

    // doSync = () => {
    //     const sync_queue = JSON.parse(localStorage.getItem('sync_queue'))

    //     var result = Promise.resolve();

    //     if (!this.lastCheck || this.lastCheck <= sync_queue.lastUpdate) {
    //         if (sync_queue.queue) {

    //             const sync_status_element_id = uuid()

    //             store.dispatch(updateGlobalState({
    //                 status_list: store.getState().app.global.status_list.concat([{
    //                     id: sync_status_element_id,
    //                     type: 'indefinite',
    //                     text: 'Sync'
    //                 },
    //                 ])
    //             }))

    //             sync_queue.queue.forEach(task => {
    //                 result = result.then(() => {
    //                     let promise

    //                     if (process.env.REACT_APP_DEBUG === '1') {
    //                         promise = Promise.resolve({
    //                             success: true
    //                         })
    //                     }
    //                     else {
    //                         promise = fetch('/evv/process_queue_item', {
    //                             method: 'POST',
    //                             body: JSON.stringify(task),
    //                             headers: {
    //                                 'Content-Type': 'application/json',
    //                                 'Accept': 'application/json',
    //                             }
    //                         }).then(result => {
    //                             return result.json().then(json => {
    //                                 return Promise.resolve(json.result)
    //                             })
    //                         })
    //                     }

    //                     return promise.then(result => {
    //                         if (result.success) {
    //                             this.lastCheck = Date.now()
    //                             // tengo que obtener la cola de nuevo, porque pudo haberse actualizado
    //                             const current_sync_queue = JSON.parse(localStorage.getItem('sync_queue'))
    //                             current_sync_queue['queue'].shift()
    //                             localStorage.setItem('sync_queue', JSON.stringify(current_sync_queue))
    //                             store.dispatch(loadData())
    //                         }

    //                         return Promise.resolve()
    //                     })
    //                         .catch(e => {
    //                             return Promise.reject()
    //                         })
    //                 });
    //             });

    //             result.finally(() => {
                
    //                 const new_status_list = [].concat(store.getState().app.global.status_list).filter(x => x.id !== sync_status_element_id)
    
    //                 store.dispatch(updateData({
    //                     status_list: new_status_list
    //                 }))
    //             })
    //         }

    //         result.catch(e => {
    //         })
    //     }

    //     result.finally(() => {
    //         if (this.continueChecking) {

    //             setTimeout(this.doSync, process.env.REACT_APP_SYNC_TIME * 1000)
    //         }
    //     })

    //     return result
    // }

    doSync = async () => {
        const sync_queue = JSON.parse(localStorage.getItem('sync_queue'))

        // var result = Promise.resolve();

        if (!this.lastCheck || this.lastCheck <= sync_queue.lastUpdate) {
            if (sync_queue.queue) {

                const sync_status_element_id = uuid()
                let reload = false
                let error = null

                store.dispatch(updateGlobalState({
                    status_list: store.getState().app.global.status_list.concat([{
                        id: sync_status_element_id,
                        type: 'indefinite',
                        text: 'Sync'
                    },
                    ])
                }))

                for(const task of sync_queue.queue){
                    let result = null

                    // if (process.env.REACT_APP_DEBUG === '1') {
                    // }
                    // else {
                    //     try{
                    //         result = await fetch('/evv/process_queue_item', {
                    //             method: 'POST',
                    //             body: JSON.stringify(task),
                    //             headers: {
                    //                 'Content-Type': 'application/json',
                    //                 'Accept': 'application/json',
                    //             }
                    //         })
                    //         result = await result.json()
                    //     }
                    //     catch(e){
                    //         result = null

                    //     }
                    // }

                    try{
                        result = await fetch('/api_evv/process_queue_item', {
                            method: 'POST',
                            body: JSON.stringify(task),
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json',
                            }
                        })
                        result = await result.json()
                        reload = true
                    }
                    catch(e){
                        result = null
                        error = e
                    }

                    if (result) {
                        if(result.error){
                            error = result.error
                        }
                        else if(result.result.success){
                            this.lastCheck = Date.now()
                            // tengo que obtener la cola de nuevo, porque pudo haberse actualizado
                            const current_sync_queue = JSON.parse(localStorage.getItem('sync_queue'))
                            current_sync_queue['queue'].shift()
                            localStorage.setItem('sync_queue', JSON.stringify(current_sync_queue))
                        }
                    }
                    
                    if(error){
                        // tengo que obtener la cola de nuevo, porque pudo haberse actualizado
                        const current_sync_queue = JSON.parse(localStorage.getItem('sync_queue'))
                        current_sync_queue.queue[0]['last_error'] = error.message
                        if(error.data){
                            current_sync_queue.queue[0]['last_error'] += ': ' + error.data.arguments[0]
                        }
                        localStorage.setItem('sync_queue', JSON.stringify(current_sync_queue))
                    }

                }

                if(reload){
                    store.dispatch(loadData())
                }
                
                const new_status_list = [].concat(store.getState().app.global.status_list).filter(x => x.id !== sync_status_element_id)

                store.dispatch(updateData({
                    status_list: new_status_list
                }))
            }

        }

        if (this.continueChecking) {

            setTimeout(this.doSync, process.env.REACT_APP_SYNC_TIME * 1000)
        }
    }

    componentDidMount() {
        this.continueChecking = true
        const temp = localStorage.getItem('sync_queue')

        if (!temp) {
            localStorage.setItem('sync_queue', JSON.stringify({
                lastUpdate: Date.now(),
                queue: []
            }))
        }

        this.doSync()
        // this.setIntervalHandler = setInterval(() => {



        // }, 10000)
    }

    componentWillUnmount() {
        // clearInterval(this.setIntervalHandler)
        this.continueChecking = false
    }

    render() {
        return null
    }
}

const mapStateToProps = (state) => {
    return {
        sync_queue: state.app.sync_queue,
    }
};

export default connect(mapStateToProps, null)(SyncQueue);